export enum ContentPanelMode {
	Designer = 'designer',
	ThreeD = 'three-d',
	Anonymous = 'anonymous',
	Loading = 'loading',
	NewSubmission = 'new-submission',
	findCustomer = 'find-customer'
}
